/**
 * Reconnect backoff (protocol.md §4.8): exponential with FULL jitter — base 1 s, factor 2, cap 30 s;
 * the healthy-connection reset is handled by the caller (WsSession).
 */
export interface BackoffConfig {
  baseMs: number;
  factor: number;
  capMs: number;
}

export const DEFAULT_BACKOFF: BackoffConfig = { baseMs: 1000, factor: 2, capMs: 30_000 };

/**
 * Delay for a given attempt (1-based). Full jitter: `random() * min(cap, base * factor^(n-1))`.
 * `random` is injectable for deterministic tests.
 */
export function backoffDelay(
  attempt: number,
  config: BackoffConfig = DEFAULT_BACKOFF,
  random: () => number = Math.random,
): number {
  const exp = config.baseMs * config.factor ** Math.max(0, attempt - 1);
  const ceiling = Math.min(config.capMs, exp);
  return Math.floor(random() * ceiling);
}
